import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const fileDownloadSlice = createSlice({
  name: 'fileDownload',
  initialState: {
    isFileDownloading: false,
  },
  reducers: {
    setIsFileDownloading: (state, action: PayloadAction<boolean>) => {
      state.isFileDownloading = action.payload;
    },
  },
});

export const { setIsFileDownloading } = fileDownloadSlice.actions;
export default fileDownloadSlice.reducer;
